import { EyeOutlined } from '@ant-design/icons';
import { Image } from 'antd';
import cn from 'classnames';

import type { TFormImageData } from '@/shared/types';

import styles from './SubjectionItem.module.scss';

interface IProp {
  firstColumnData: string;
  secondColumnData: string;
  thirdColumnData?: TFormImageData;
}

export const SubjectionItem = ({ firstColumnData, secondColumnData, thirdColumnData }: IProp) => (
  <div className={cn(styles.wrapper, { [styles['wrapper-extended']]: thirdColumnData })}>
    <p>{firstColumnData}</p>
    <p>{secondColumnData}</p>
    {thirdColumnData?.url && (
      <Image
        className={styles.image}
        width={34}
        height={34}
        src={thirdColumnData?.url}
        preview={{
          cover: <EyeOutlined />,
        }}
      />
    )}
  </div>
);
